<template>
    <div class="d-flex flex-sm-row flex-column align-items-start justify-content-center" ref="search_box">
        <div class="type_selection_wrapper">
            <div class="type_selection py-2">
                <multiselect v-model="type" v-bind="typeMultiselectSettings" @search-change="searchSubjects"
                    ref="change_type_form_focus" :placeholder="$t('placeholder')" class="type_multiselect">
                    <template #option="optionProps">
                        <div class="d-flex justify-content-start align-items-center">
                            <span class="fi fi-big" :class="'fi-' + optionProps.option.flag" v-if="optionProps.option.flag"></span>
                            <span class="person-icon" v-if="optionProps.option.icon"> <img :src="'/static/v2/img/' + optionProps.option.icon + '.svg'"></span>
                            <span class="ms-3">{{ $t("types." + optionProps.option.id) }}</span>
                        </div>
                    </template>
                    <template #singleLabel="searchProps">
                        <div class="d-flex justify-content-center align-items-center type_selected" style="margin-top: 2px;">
                            <span class="fi fi-big me-2" :class="'fi-' + searchProps.option.flag" v-if="searchProps.option.flag"></span>
                            <span class="person-icon me-2" v-if="searchProps.option.icon"> <img :src="'/static/v2/img/' + searchProps.option.icon + '.svg'"></span>
                            <span class="text-start"> {{ $t("types." + searchProps.option.id) }}</span>
                        </div>
                    </template>
                    <template #caret="toggle">
                        <div class="toggle_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" width="24" height="24" stroke-width="2"> <path d="M6 10l6 6l6 -6h-12"></path> </svg>
                        </div>
                    </template>
                </multiselect>
            </div>
        </div>
        <div class="form_wrapper">
            <div v-if="type.id == 'cz' || type.id == 'sk' || (type.id == 'global' && !moodysDown)" class="py-2">
                <multiselect v-model="selectedSubject" v-bind="multiselectSettings" @open="openSearchSubjects" @close="isDropdownOpen = false" @search-change="searchSubjects"
                    @mousedown.stop tabindex="-1" ref="search_form_focus" :placeholder="$t('placeholder')" class="search_multiselect" >
                    <template #option="optionProps">
                        <div class="d-flex justify-content-between align-items-center" v-if="type.id == 'cz'">
                            <span :style="{'color': activeCzechSubjectColor(optionProps.option)}">
                                {{ optionProps.option.name }} ({{ $t("organizationId") }} <i>{{ optionProps.option.organization_id }}</i>)
                                <span v-if="!optionProps.option.active"><br>{{ $t("inactive") }}</span>
                            </span>
                        </div>
                        <div class="d-flex justify-content-between align-items-center" v-if="type.id == 'sk'">
                            <span :style="{'color': activeSlovakSubjectColor(optionProps.option)}">
                                {{ optionProps.option.name }} ({{ $t("organizationId") }} <i>{{ optionProps.option.organization_id ? optionProps.option.organization_id : $t("notProvided") }}</i>)
                                <span v-if="!optionProps.option.active"><br>{{ $t("inactive") }}</span>
                            </span>
                        </div>
                        <div class="d-flex justify-content-between align-items-center" v-else-if="type.id == 'global'">
                            <span>
                                <span v-if="optionProps.option.country"
                                    class="fi " :class="'fi-' + optionProps.option.country.toLowerCase()"></span>
                                <b class="ms-2" :style="{'color': nameColor(optionProps.option)}">
                                    <span>{{ optionProps.option.name }}</span>
                                    <span v-if="isBranch(optionProps.option)"> ({{$t("branch")}})</span>
                                </b><br>
                                <span v-if="optionProps.option.street">
                                    {{ optionProps.option.street }},
                                </span>
                                <span v-if="optionProps.option.city">
                                    <span v-if="optionProps.option.postcode">{{ optionProps.option.postcode }} </span>
                                    {{ optionProps.option.city }},
                                </span>
                                <span v-if="optionProps.option.full_country">
                                    {{ optionProps.option.full_country }} ({{ optionProps.option.country }})
                                </span>
                                <span v-else>
                                    {{ optionProps.option.country }}
                                </span>
                                <br>
                                <span v-if="optionProps.option.organization_id_label && optionProps.option.organization_id">
                                    {{ optionProps.option.organization_id_label }}: {{ optionProps.option.organization_id }}
                                </span>
                            </span>
                        </div>
                    </template>
                    <template #noResult>
                        <div v-if="isLoading" class="text-muted">
                            <span v-if="type.id == 'cz'">
                                {{ $t("searching") }}
                            </span>
                            <span v-else-if="type.id == 'sk'">
                                {{ $t("searching") }}
                            </span>
                            <div v-else-if="type.id == 'global'" class="d-flex align-items-center justify-content-center">
                                <div class="d-flex align-items-center justify-content-center flex-row">
                                    <div>
                                        <div class="spinner-grow" role="status"></div>
                                    </div>
                                    <span class="ms-3">{{ $t("international.searching") }}</span>
                                </div>
                            </div>
                        </div>
                        <span v-else class="text-muted">
                                <span v-if="type.id == 'cz' || type.id == 'sk'">{{ $t("changeType." + type.id )}}
                                    <a @click="openChangeType" href="#"> {{ $t("changeType.here") }}</a></span>
                                <span v-else-if="error">{{ $t("international.downService") }}</span>
                                <span v-else>{{ $t("nothingFound") }}</span>
                        </span>
                    </template>
                    <template #noOptions class="text-muted">{{ $t("startWritting") }}</template>
                    <template #beforeList>
                        <template v-if="type.id==='global' && advancedVisible">
                            <div
                            class="before-list-types multiselect-keep-open advanced-bar ps-0 pe-0 d-flex"
                            @mousedown.stop="handleAdvancedClick"
                            >
                            <InternationalAdvancedSearch
                                ref="advancedSearch"
                                :advancedVisible="advancedVisible"
                                :countries="countryOptions"
                                v-model:cityValue="searchCity"
                                v-model:countryValue="searchCountryObject"
                                @keep-open="keepOpen"
                                @allow-close="allowClose" />
                            </div>
                        </template>

                        <template v-else-if="subjects.length > 0">
                            <div class="before-list-types d-flex py-1 ps-3 justify-content-between align-items-center">
                            <div>
                                {{ $t("changeType." + type.id) }}
                                <a href="#" @click="openChangeType">{{ $t("changeType.here") }}</a>
                            </div>
                            </div>
                        </template>
                    </template>
                    <template #afterList v-if="subjects.length > 8 && type.id == 'cz'">
                        <div class="d-flex py-1 ps-3 justify-content-between align-items-center before-list-types">
                            <div>
                                {{ $t("changeType.didntFound" )}}
                                <a @click="openChangeType" href="#"> {{ $t("changeType.here") }}</a>
                            </div>
                        </div>
                    </template>
                </multiselect>
            </div>
            <template v-else-if="type.id == 'global' && moodysDown">
                <div class="text-start px-4 py-3 row h-100">
                    <div class="col-12">
                        {{ $t("international.errors.ongoingRepair") }}
                    </div>
                </div>
            </template>
            <button
                v-if="type.id==='global' && isDropdownOpen"
                class="btn btn-link p-0 position-absolute search-icon responsive-search-icon"
                style="top:50%; right:20px; transform:translateY(-50%); z-index:10;"
                @mousedown.prevent
                @click.stop="advancedVisible = !advancedVisible"
                :title="$t('search.advanced')"
                >
                <img :src="`/static/v2/img/${advancedSearchIcon}.svg`" alt="Advanced Search"/>
            </button>
            <template v-else-if="type.id == 'person'">
                <PersonFinder/>
            </template>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import PersonFinder from './PersonFinder.vue';
import InternationalAdvancedSearch from './InternationalAdvancedSearch.vue';
import axios from "axios";

const api = axios.create({
    baseURL: "/api/",
    withCredentials: true,
    xsrfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFToken"
});

export default {
    components: {
        Multiselect,
        PersonFinder,
        InternationalAdvancedSearch
    },
    data() {
        return {
            subjects: [],
            selectedSubject: null,
            isLoading: false,
            cancelToken: null,
            searchTimer: null,
            query: null,
            error: false,
            debounceTime: 700,
            moodysDown: false,
            types: [
                {
                "flag": "global",
                "id": "global"
                },
                {
                "icon": "person",
                "id": "person"
                }
            ],
            type: { id: "global" },
            advancedVisible: false,
            searchCity: '',
            searchCountryObject: null,
            countryOptions: [],
            advancedSearchIcon: 'advanced-search',
            isDropdownOpen: false,
            slovakEnabled: false,
            czechEnabled: false
        }
    },
    created: function() {
      const lang = document.getElementById("language").innerText;
      api.get("countries/" + lang)
         .then(r => { this.countryOptions = r.data.countries });
    },
    mounted: function () {
        document.addEventListener('click', this.handleDocumentClick);

        // Suppress vue-multiselect's blur->deactivate when focus moves to a child input
        // inside the .multiselect-keep-open zone (city input, country dropdown). Without this,
        // opening the country select inside the advanced panel would close the parent dropdown.
        this.$nextTick(() => {
            const ms = this.$refs.search_form_focus;
            const searchInput = ms && ms.$refs && ms.$refs.search;
            if (!searchInput) return;
            searchInput.addEventListener('blur', (event) => {
                const keepOpen = ms.$el.querySelector('.multiselect-keep-open');
                const related = event.relatedTarget;
                if (keepOpen && related && keepOpen.contains(related)) {
                    event.stopImmediatePropagation();
                }
            }, true);
        });

        const slovakFlagEl = document.getElementById('slovak_search_enabled');
        this.slovakEnabled = slovakFlagEl && slovakFlagEl.innerText.trim() === '1';

        const czechFlagEl = document.getElementById('czech_search_enabled');
        this.czechEnabled = czechFlagEl && czechFlagEl.innerText.trim() === '1';

        if (this.slovakEnabled === true && this.czechEnabled === false) {
            this.types = [
                {
                "flag": "global",
                "id": "global"
                },
                {
                "icon": "person",
                "id": "person"
                },
                {
                "flag": "sk",
                "id": "sk",
                }
            ];
            }

        if (this.slovakEnabled === false && this.czechEnabled === true) {
            this.types = [
                {
                "flag": "global",
                "id": "global"
                },
                {
                "icon": "person",
                "id": "person"
                },
                {
                "flag": "cz",
                "id": "cz",
                }
            ];
            }

        if (this.slovakEnabled === true && this.czechEnabled === true) {
            this.types = [
                {
                "flag": "global",
                "id": "global"
                },
                {
                "icon": "person",
                "id": "person"
                },
                {
                "flag": "cz",
                "id": "cz",
                },
                {
                "flag": "sk",
                "id": "sk",
                }
            ];
            }

        this.$i18n.locale = document.getElementById("language").innerText;
        this.type = this.types[0];

        const portalSearch = document.getElementById('portal_search').innerText;
        if (portalSearch === 'cz') {
            const portalTypes = [
                { flag: 'global', id: 'global' },
                { icon: 'person', id: 'person' }
            ];

            if (this.czechEnabled) {
                portalTypes.splice(0, 0, { flag: 'cz', id: 'cz' });
            }

            if (this.slovakEnabled) {
                portalTypes.splice(1, 0, { flag: 'sk', id: 'sk' });
            }

            this.types = portalTypes;
            this.type = this.types[0];
        }

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const searchParam = urlParams.get("search");
        const selectTypeIfAvailable = (id) => {
           const option = this.types.find(t => t.id === id);
            if (option) {
                this.type = option;
            }
        };

        if (searchParam === "international") {
            selectTypeIfAvailable("global");
        } else if (searchParam === "person") {
            selectTypeIfAvailable("person");
        } else if (searchParam === "cz") {
            selectTypeIfAvailable("cz");
        } else if (searchParam === "sk") {
            selectTypeIfAvailable("sk");
        }

    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleDocumentClick);
    },
    computed: {
        multiselectSettings: function () {
            return {
                label: "name",
                trackBy: "id",
                placeholder: "",
                options: this.subjects,
                searchable: true,
                internalSearch: false,
                clearOnSelect: false,
                showLabels: false,
                preserveSearch: true,
                openDirection: "bottom",
                optionHeight: 60
            }
        },
        typeMultiselectSettings: function () {
            return {
                label: "flag",
                trackBy: "id",
                placeholder: "",
                options: this.types,
                searchable: false,
                internalSearch: false,
                clearOnSelect: false,
                showLabels: false,
                preserveSearch: false,
                openDirection: "bottom",
                optionHeight: 60,
                allowEmpty: false
            }
        },
        subjectLink: function () {
            var object = this.selectedSubject;
            this.selectedSubject = null;
            if (this.type.id === 'sk') {
                return `/subject/sk/id/${object.body_id}`;
            } else if (this.type.id === 'cz') {
                return `/subject/cz/id/${object.body_id}`;
            } else {
                return `/subject/${object.organization_id}`;
            }
        },
        internationalSubjectLink: function () {
            var object = this.selectedSubject;
            var link = this.selectedSubject.link;
            this.selectedSubject = null;
            return object ? `/subject/verify/${link}` : null
        },
    },
    watch: {
        selectedSubject: function (selectedSubject) {
            this.gotToSubject();
        },
        type: function () {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
                this.searchTimer = null;
            }
            if (this.cancelToken != null) {
                this.cancelToken.cancel("Operation canceled by the user.");
                this.cancelToken = null;
            }
            this.isLoading = false;
            this.subjects = [];
            const massWrapper = document.getElementById("mass_search_wrapper");
            const massLink = document.getElementById("mass_check_link");

            if (this.type && this.type.id == "global") {
                document.getElementById("powered_by_externals").classList.remove("d-none")
            }
            else if (!document.getElementById("powered_by_externals").classList.contains("d-none")) {
                document.getElementById("powered_by_externals").classList.add("d-none")
            }

            if (this.type && this.type.id === "cz") {
                massWrapper?.classList.remove("d-none");
                if (massLink) massLink.href = "/hromadne-provereni?source_country=cz";
            } else if (this.type && this.type.id === "sk") {
                massWrapper?.classList.remove("d-none");
                if (massLink) massLink.href = "/hromadne-provereni?source_country=sk";
            } else {
                massWrapper?.classList.add("d-none");
            }

            if (this.type && this.type.id == "person") {
                this.$refs.search_box.classList.add("person_search");
            }
            else {
                this.$refs.search_box.classList.remove("person_search");
            }
        },
        advancedVisible(newVal) {
            if (!newVal && this.$refs.advancedSearch) {
                this.$refs.advancedSearch.closeMultiselectDropdown();
            }
        },
        searchCity() {
            if (this.type.id === 'global') {
                this.searchSubjects(this.query || '');
            }
        },
        searchCountryObject() {
            if (this.type.id === 'global') {
                this.searchSubjects(this.query || '');
            }
        },
        subjects: function () {
            var main = this.$refs.search_form_focus.$el;
            if (!main) {
                return
            }
            var elements = main.getElementsByClassName("multiselect__content-wrapper");
            if (!elements || elements.length == 0) {
                return
            }
            var element = elements[0];
            if (this.subjects && this.subjects.length > 5) {
                element.classList.add("hide_border_radius");
            }
            else {
                element.classList.remove("hide_border_radius");
            }
        }
    },
    methods: {
        isBranch: function (data) {
            return data.legal_form == "Branch";
        },
        nameColor: function (data) {
            if (this.isBranch(data)) {
                return "grey";
            }
            return "black";
        },
        activeCzechSubjectColor: function (data) {
            if (data.active) {
                return "black";
            }
            return "grey";
        },
        activeSlovakSubjectColor: function (data) {
            if (data.active) {
                return "black";
            }
            return "grey";
        },
        openSearchSubjects: function () {
            this.isDropdownOpen = true;
            if (this.subjects.length == 0 && this.query) {
                this.searchSubjects(this.query);
            }
        },
        searchSubjects: function (query) {
            this.error = false;
            this.query = query;
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }

            if (this.cancelToken != null) {
                this.cancelToken.cancel("Operation canceled by the user.");
                this.cancelToken = null;
            }

            if (!query || query.length < 3) {
                return;
            }

            this.isLoading = true;
            this.subjects = [];
            this.actualString = query;

            let params = {
                q: query,
                limit: 50,
                offset: 0
            }

            this.searchTimer = setTimeout(function () {
                this.cancelToken = axios.CancelToken.source();
                if (this.type.id == 'cz') {
                    this.czechSearch(params, query)
                }
                else if (this.type.id == 'global') {
                    this.internationalSearch(params, query)
                }
                else if (this.type.id == 'sk') {
                    this.slovakSearch(params, query)
                }
            }.bind(this), this.debounceTime);
        },
        czechSearch: function (params, query) {
            api.get("find", { params: params, cancelToken: this.cancelToken.token })
                .then(r => {
                    if (query == this.actualString) {
                        this.subjects = r.data;
                    }
                })
                .catch(e => {
                    if (axios.isCancel(e)) {
                        console.log("Request canceled", e.message);
                    } else {
                        console.log(e);
                    }
                })
                .finally(() => {
                    this.cancelToken = null;
                    if (query == this.actualString) {
                        this.isLoading = false;
                    }
                })
        },
        slovakSearch: function (params, query) {
            api.get("find/sk", { params: params, cancelToken: this.cancelToken.token })
                .then(r => {
                    if (query == this.actualString) {
                        this.subjects = r.data;
                    }
                })
                .catch(e => {
                    if (axios.isCancel(e)) {
                        console.log("Request canceled", e.message);
                    } else {
                        console.log(e);
                    }
                })
                .finally(() => {
                    this.cancelToken = null;
                    if (query == this.actualString) {
                        this.isLoading = false;
                    }
                })
        },
        internationalSearch: function (params, query) {
            if (this.searchCity) {
                params.city = this.searchCity;
            }
            if (this.searchCountryObject) {
                params.country = this.searchCountryObject.iso;
            }

            api.get("find/international", { params: params, cancelToken: this.cancelToken.token })
                .then(r => {
                    if (query == this.actualString) {
                        this.subjects = r.data.subjects;
                    }
                })
                .catch(e => {
                    if (axios.isCancel(e)) {
                        console.log("Request canceled", e.message);
                    } else {
                        if (e.response.status >= 400) {
                            this.error = true;
                        }
                        else {
                            console.log(e);
                        }
                    }
                })
                .finally(() => {
                    this.cancelToken = null;
                    this.isLoading = false;
                })
            },
            gotToSubject: function () {
                if (this.type.id == 'cz') {
                    window.location.href = this.subjectLink;
                }
                else if (this.type.id == 'global') {
                    window.location.href = this.internationalSubjectLink;
                }
                else if (this.type.id == 'sk') {
                    window.location.href = this.subjectLink;
                }
            },
            openChangeType: function () {
                this.$refs.change_type_form_focus.activate()
            },
            handleAdvancedClick(event) {
                const target = event.target;
                // Only preventDefault for non-focusable targets so clicking the city input or
                // country search input can still receive focus. Without this, the .stop modifier
                // on its own is fine, but blur of main input is suppressed via the listener in
                // mounted() for keep-open zone elements.
                if (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') {
                    event.preventDefault();
                }
                const isInput = target.tagName === 'INPUT' || target.closest('.multiselect');
                if (!isInput) {
                    this.keepOpen();
                }
            },
            keepOpen () {
                setTimeout(() => {
                    this.isDropdownOpen = true;
                    const ms = this.$refs.search_form_focus;
                    if (ms) {
                        ms.isOpen = true;
                    }
                }, 0);
            },
            allowClose() {
                if (this.isDropdownOpen) {
                    this.isDropdownOpen = false;
                    const ref = this.$refs.search_form_focus;
                    if (ref && typeof ref.deactivate === 'function') {
                        ref.deactivate();
                    }
                }
            },
            handleDocumentClick(event) {
                const target = event.target;
                const multiselect = this.$refs.search_form_focus;
                const advancedSearch = multiselect?.$el.querySelector('.multiselect-keep-open');
                const teleportedDropdown = target.closest('.country-dropdown-teleported');

                const insideMain = multiselect?.$el.contains(target);
                const insideAdv = advancedSearch && advancedSearch.contains(target);
                const insideTele = !!teleportedDropdown;
                const inCountryField = target.closest('.multiselect_advanced_country');

                // Close the country dropdown whenever the click lands outside it
                // (including inside the main search list or city input).
                const advRef = this.$refs.advancedSearch;
                const countryMs = advRef && advRef.$refs.countryMultiselect;
                if (countryMs && countryMs.isOpen && !inCountryField && !insideTele) {
                    countryMs.deactivate();
                }

                if (!insideMain && !insideAdv && !insideTele) {
                    if (advRef) {
                        advRef.closeMultiselectDropdown();
                    }
                    this.allowClose();
                }
            }
    }
}
</script>

<style scoped>
</style>
